import React from 'react'
import ItemTypes from '../../lib/item_types'

export default class SignatureSettings extends React.Component {

  onChange = (e) => {
    const { item, path, handlers } = this.props
    handlers.updateItemAttr(e, item, ItemTypes.ELEMENT.type, path)
  }

  render () {
    const { caption } = this.props.item

    return (
      <div className="signature-settings">
        <div className="form-group">
          <label>Caption</label>
          <input type="text" className="form-control" name="caption" value={caption}  onChange={this.onChange} />
        </div>
      </div>
    )
  }
}
